import callApi from '../../util/apiCaller.js';

import { addError } from '../Error/ErrorActions.js';
import { getVatRateForCountry } from './VatHelpers.js';

// Export Constants
export const SET_VAT_RATES = 'SET_VAT_RATES';

// Export Request Actions
export function getVatRatesRequest() {
	return dispatch => {
		return callApi('vatrates').then(res => {
			res.vatRates && dispatch(setVatRates(res.vatRates));
			return res.vatRates;
		}).catch(error => {
			dispatch(addError(error));
			return null;
		});
	};
}

export function getVatReportRequest({ from, to, dateField }) {
	return dispatch => {
		return callApi(`vatrates/report?from=${from}&to=${to}&dateField=${dateField}`).catch(error => {
			dispatch(addError(error));
			return null;
		});
	};
}

export function editVatRatesRequest(vatRates) {
	return dispatch => {
		return callApi('vatrates/edit', 'post', { vatRates }).then(res => {
			res.vatRates && dispatch(setVatRates(res.vatRates));
			return res.vatRates;
		}).catch(error => {
			dispatch(addError(error));
			return null;
		});
	};
}

// Getters
export function getVatRates(store) {
	return store.vatRates.data;
}

export function getVatRate(store, countryCode) {
	return getVatRateForCountry(getVatRates(store), countryCode);
}

// Actions
export function setVatRates(vatRates) {
	return {
		type: SET_VAT_RATES,
		vatRates,
	};
}
